import JSConfetti from 'js-confetti'

const jsConfetti = new JSConfetti()

export function lancarConfete() {
	jsConfetti.addConfetti({
		confettiNumber: 800
	})
}
